<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Route Wizard</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <!-- <pre>{{ vm.routeLegs | json }}</pre> -->
    <ion-list-header color="secondary" data-test="listHeader">
        Save Route - (Step 6 of 8)
    </ion-list-header>

    <ion-list class="ion-text-wrap ion-no-padding">
        @for (leg of vm.routeLegs; track $index) {
  <ion-item ion-no-padding data-test="legs">
            <label class="ion-text-wrap" [class.urgent]="leg.isUrgent">
                <ion-grid>
                    <ion-row class="ion-align-items-center">
                        <ion-col class="letterCol ion-float-left" size="3">
                            <span class="letter">{{leg.waypointNumber}}</span>
                        </ion-col>
                        <ion-col class="legDescCol ion-float-right" size="9">
                            <span class="line1">From: {{leg.from.location.locationName}}</span><br />
                            <!-- @if (leg.from.address !== this.vm.dealership.address) {
  <div> -->
                            <span class="line2">{{leg.from.location.address.streetAddress}}</span><br />
                            <!-- </div>
} -->

                            <span class="line1">To: {{leg.to.location.locationName}}</span><br />
                            <!-- @if (leg.to.address !== this.vm.dealership.address) {
  <div> -->
                            <span class="line2">{{leg.to.location.address.streetAddress}}</span><br />
                            <!-- </div>
} -->
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </label>
        </ion-item>
}
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]="vb.disabled || !vm.step6Complete" title="Next" (click)="onNextClick()"
            data-test="routeNext6">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" [disabled]="vb.disabled || vm.step6Complete" expand="full"
            (click)="onSaveRouteClick()" href="javascript:;" data-test="saveRoute">Save Route</ion-button>
    </ion-toolbar>
</ion-footer>